import * as model from "./model.js";

import "core-js/stable";
import "regenerator-runtime/runtime";
import { async } from "regenerator-runtime";
import ProductsView from "./views/productsView.js";
import WinnersView from "./views/winnersView.js";
import FinalistsSelectView from "./views/finalistsSelectView.js";
import { checkImages } from "./helpers.js";
import FinalistsView from "./views/finalistsView.js";

// model.loadProducts(1645, "00000000");

const controlCategoryResults = async function () {
	try {
		// 2) Load search results
		await model.loadProducts(1645, "10000000");

		// 3) Render results
		ProductsView.render(model.state.products);
	} catch (err) {
		console.log(err);
	}
};

const controlWinnersContent = async function () {
	try {
		await model.loadWinners(1645, "10000000");

		WinnersView.render(model.state.products);
	} catch (err) {
		console.log(err);
	}
};

const controlFinalistsContent = async function ($id) {
	try {
		await model.loadFinalistsCategory(1645, $id, "10000000");

		FinalistsView.render(model.state.products);
	} catch (err) {
		console.log(err);
	}
};

const init = function () {
	controlCategoryResults();

	ProductsView.addHandlerClick();
	// FinalistsView.addHandlerClick();
	ProductsView.addHandlerLoad();
	FinalistsSelectView.addHandlerClick(controlFinalistsContent);
	WinnersView.addHandlerRender(controlWinnersContent);
	checkImages();
};
init();
